import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CompanyModel} from '../../../../../shared/models/company.model';
import {PortfolioService} from '../../../portfolio.service';
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-new-portfolio-select-dialog',
  templateUrl: './new-portfolio-select-dialog.component.html',
  styleUrls: ['./new-portfolio-select-dialog.component.scss'],
  standalone: true,
  imports: [MaterialModule, FormsModule, DecimalPipe, CommonModule]
})
export class NewPortfolioSelectDialogComponent {

  @Input() list: any[] = [];
  selected: any[] = [];
  weightError = false;
  hasETF = false;
  @Input() portfolio: any = null;
  @Output() itemRemove: EventEmitter<any> = new EventEmitter<any>();
  constructor(
      private service: PortfolioService
  ) {
  }

  onRemoveClick() {
    this.list.forEach(item => {
      if (item.markedForDelete) {
        this.itemRemove.emit({
          company: item,
          isSelected: false
        });
      }
    });
    this.list = this.list.filter(i => !i.markedForDelete);
    this.selected = [];

    this.recalculateWeight();
    this.checkETF();
  }

  onSelect(value, item) {
    this.selected = this.selected.includes(item) ? this.selected.filter(i => i !== item) : [ ...this.selected, item ];
    item.markedForDelete = value.checked;
  }

  recalculateMarketCapWeight() {
    let freeWeight = 100;

    if (this.hasETF) {
      freeWeight = 100 - this.portfolio.etfPercent;
      const selectedETFLength = this.list.filter(c => c.isETF()).length;
      this.list = this.list.map((company: CompanyModel) => {
        if (!company.isStock()) {
          company.weight = +(this.portfolio.etfPercent / selectedETFLength).toFixed(2);
        }
        return company;
      });
    }
    let totalMarketCap = 0;
    this.list.map((company: CompanyModel) => {
      if (company.isStock()) {
        totalMarketCap += +company.market_value_usd;
      }
    });
    this.list = this.list.map((company: CompanyModel) => {
      if (company.isStock()) {
        company.weight = +(+company.market_value_usd/totalMarketCap*freeWeight).toFixed(2);
      }
      return company;
    });
  }

  recalculateWeight() {
    if (this.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight();
      return;
    }

    // recalculate equal weights
    let selectedStockLength = this.list.filter(c => c.isStock()).length + this.list.filter(c => c.isFund()).length + this.list.filter(c => c.isETF()).length;
    let freeStockWeight = 100;


    if (selectedStockLength) {
      this.list.map((company: CompanyModel) => {
        if (company.weightManuallyAdjusted) {
          selectedStockLength -= 1;
          freeStockWeight -= company.weight;
        }
      });

      const baseWeight = +(freeStockWeight / selectedStockLength).toFixed(2);
      const lastWeight = +(freeStockWeight - baseWeight * (selectedStockLength - 1)).toFixed(2);
      let adjustableIndex = 0;

      this.list = this.list.map((company: CompanyModel) => {
        if (!company.weightManuallyAdjusted) {
          adjustableIndex++;
          company.weight = adjustableIndex === selectedStockLength ? lastWeight : baseWeight;
        }
        return company;
      });
      this.weightError = freeStockWeight < 0;
    }

  }

  onWeightTypeChange() {
    if (this.portfolio.weighting_type === 'equal') { // equal
      this.list = this.list.map((company: CompanyModel) => {
        company.weightManuallyAdjusted = false;
        return company;
      });
      this.recalculateWeight();
    } else if (this.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight()
    }
  }

  onWeightChange(company) {
    this.portfolio.weighting_type = 'manual';
    company.weightManuallyAdjusted = company.weight;
  }

  checkETF() {
    this.hasETF = this.service.hasETF(this.list);
  }
}
